<template>
    <VForm
        v-slot="{ errors }"
        @submit="onSubmit">
        <div class="flex flex-col gap-6">
            <BaseInput
                v-model="model.email"
                :label="$t('auth.email')"
                rules="required|email|max:255"
                required
                type="email"
                name="email"
                autocomplete="username" />
            <BaseInput
                v-model="model.password"
                :label="$t('auth.password')"
                rules="required"
                required
                type="password"
                name="password"
                autocomplete="current-password" />

            <div class="flex flex-col sm:flex-row gap-4 justify-between items-center">
                <div>
                    <BaseCheckbox
                        v-model="model.remember"
                        name="stayLoggedIn">
                        {{ $t('auth.stayLoggedIn') }}
                    </BaseCheckbox>
                </div>
                <div class="text-sm">
                    <span
                        class="font-semibold text-primary-600 hover:text-primary-500 cursor-pointer"
                        @click.prevent="$emit('authPageVisible', AuthForgotPassword)">
                        {{ $t('auth.forgotPassword') }}
                    </span>
                </div>
            </div>

            <BaseButton
                class="w-full"
                color="primary"
                :disabled="loading || !!Object.keys(errors).length"
                type="submit">
                <span v-if="!loading">{{ $t('auth.login') }}</span>
                <span v-else>
                    <LoadingSpinner />
                    {{ $t('auth.pleaseWait') }}
                </span>
            </BaseButton>
        </div>
    </VForm>
</template>

<script setup>
import AuthForgotPassword from "@/components/pages/auth/AuthForgotPassword.vue"
import AuthRegister from "@/components/pages/auth/AuthRegister.vue"
import AuthTwoFactorChallenge from "~/components/pages/auth/AuthTwoFactorChallenge.vue"
import {useAuthStore} from '~/store/auth'

const authStore = useAuthStore()
const notification = useNotification()
const {$apiRoute} = useNuxtApp()

const emits = defineEmits(['authPageVisible'])

const model = ref({
    email: null,
    password: null,
    remember: true
})

const loading = ref(false)

async function onSubmit() {
    loading.value = true

    const response = await $lara.post($apiRoute('spa.login.authenticate'), {body: model.value})
    loading.value = false

    if (response?.error) return notification.error(response.error.data?.message)
    if (response.two_factor) emits('authPageVisible', AuthTwoFactorChallenge)
    else await authStore.successfulLogin()
}
</script>